import {
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseSiteService } from '@spartacus/core';
import { of, Subscription } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { BaseService } from 'src/app/shared/services/base.service';
import * as config from '../../../app/shared/config/app.config';
import { CustomerHierarchyService } from '../customer-hierarchy.service';

@Component({
  selector: 'app-assign-approvers',
  templateUrl: './assign-approvers.component.html',
  styleUrls: ['./assign-approvers.component.scss'],
  standalone: false,
})
export class AssignApproversComponent implements OnInit, OnDestroy {
  @ViewChild('autoCompleteInput', { read: MatAutocompleteTrigger })
  autoComplete: MatAutocompleteTrigger;
  @ViewChild('autoCompleteInput1', { read: MatAutocompleteTrigger })
  autoComplete1: MatAutocompleteTrigger;
  @ViewChild('autoCompleteInput2', { read: MatAutocompleteTrigger })
  autoComplete2: MatAutocompleteTrigger;
  @Input() public type;
  @Input() aprroverDetails;
  @Input() parentNode: string;
  approverForm: FormGroup;
  approversList: FormArray;
  searchApproversList = [];
  b2bUnit: any;
  baseSiteId: string;
  errorMsg: string = '';
  submitted: boolean;
  showNoResults = false;
  baseSiteSub: Subscription;
  baseSub: Subscription;
  approverSub: Subscription;
  serviceSub: Subscription;

  constructor(
    private readonly modalService: NgbModal,
    private readonly formBuilder: FormBuilder,
    private readonly serviceClass: CustomerHierarchyService,
    private readonly cdr: ChangeDetectorRef,
    private readonly baseService: BaseService,
    private readonly baseSiteService: BaseSiteService
  ) {}

  ngOnInit(): void {
    window.addEventListener('scroll', this.scrollEvent, true);
    this.baseSiteSub = this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.baseSub = this.baseService
      .get(config.GET_ACCOUNT_ID)
      .pipe(take(1))
      .subscribe((res) => {
        this.b2bUnit = res?.defaultB2BUnit?.uid;
      });
    this.approverForm = new FormGroup({
      items: new FormArray([]),
    });
    this.addApprovers();
    if (this.type === 'edit') {
      let data = this.updateDatareate();
      let formArrays = this.approverForm.get('items') as FormArray;
      formArrays.controls[0].patchValue(data);
      this.submitted = false;
      this.cdr.detectChanges();
    }
    this.approverSub = this.approverForm.valueChanges.subscribe((value) => {
      this.submitted = false;
    });
  }
  ngOnDestroy(): void {
    this.baseSiteSub?.unsubscribe();
    this.baseSub?.unsubscribe();
    this.approverSub?.unsubscribe();
    this.serviceSub?.unsubscribe();
    window.removeEventListener('scroll', this.scrollEvent, true);
  }

  scrollEvent = (event: any): void => {
    if (this.autoComplete.panelOpen) this.autoComplete.updatePosition();
    if (this.autoComplete1.panelOpen) this.autoComplete1.updatePosition();
    if (this.autoComplete2.panelOpen) this.autoComplete2.updatePosition();
  };
  updateDatareate() {
    let obj = {
      approverName: this.aprroverDetails?.approver?.name,
      approverPhoneNumber: this.aprroverDetails?.phoneNo,
      approverUid: this.aprroverDetails?.approver?.uid,
      approverSapId: this.aprroverDetails?.uid,
      threshold: this.aprroverDetails?.thresholdValue,
      delegate1Name: this.aprroverDetails?.delegatesList?.[0]?.delegate?.name,
      delegate1PhoneNumber: this.aprroverDetails?.delegatesList?.[0]?.phoneNo,
      delegate1Uid: this.aprroverDetails?.delegatesList?.[0]?.delegate?.uid,
      delegate1SapId: this.aprroverDetails?.delegatesList?.[0]?.uid,
      delegate1Active: false,
      delegate2Name: this.aprroverDetails?.delegatesList?.[1]?.delegate?.name,
      delegate2PhoneNumber: this.aprroverDetails?.delegatesList?.[1]?.phoneNo,
      delegate2Uid: this.aprroverDetails?.delegatesList?.[1]?.delegate?.uid,
      delegate2SapId: this.aprroverDetails?.delegatesList?.[1]?.uid,
      delegate2Active: false,
    };
    return obj;
  }

  createApproverItem(): FormGroup {
    return this.formBuilder.group({
      approverName: ['', Validators.required],
      approverPhoneNumber: [
        '',
        [Validators.required, Validators.pattern('[0-9-]{12}')],
      ],
      approverUid: [''],
      approverSapId: [''],
      threshold: ['', Validators.required],
      delegate1Name: [''],
      delegate1PhoneNumber: ['', [Validators.pattern('[0-9-]{12}')]],
      delegate1Uid: [''],
      delegate1SapId: [''],
      delegate1Active: [false],
      delegate2Name: [''],
      delegate2PhoneNumber: ['', [Validators.pattern('[0-9-]{12}')]],
      delegate2Uid: [''],
      delegate2SapId: [''],
      delegate2Active: [false],
    });
  }
  addApprovers() {
    this.approversList = this.approverForm.get('items') as FormArray;
    this.approversList.push(this.createApproverItem());
  }
  toggleAccordion(item, deligate) {
    let val = item.get(deligate).value;
    (<FormGroup>item)?.controls[deligate].setValue(!val);
  }

  getExpandedItems(item, deligate): boolean {
    let val = item.get(deligate).value;
    return val || false;
  }
  cancelPopup() {
    this.modalService.dismissAll();
  }
  getControls() {
    return (this.approverForm.get('items') as FormArray).controls;
  }
  updateMySelection(event, itemControl, controlName, controlOption) {
    let value = event.option._element.nativeElement.OptionValue;
    (<FormGroup>itemControl)?.controls[controlOption].setValue(value?.uid);
  }
  searchApprovers(itemControl, controlName, uidName, contactType, focus?) {
    let val = itemControl.get(controlName).value;
    if (focus !== 'focus') {
      (<FormGroup>itemControl)?.controls[uidName].setValue('');
    }
    if (val !== '') {
      itemControl.get(uidName).setValidators([Validators.required]);
    } else {
      itemControl.get(uidName).clearValidators();
    }
    itemControl.get(uidName).updateValueAndValidity();
    if (val !== '') {
      of(val)
        .pipe(
          switchMap((val) =>
            this.serviceClass.getSearchApprovers({
              contactType: contactType,
              customerUnit: this.b2bUnit,
              nodeOrApproverId: this.parentNode,
              searchText: val,
            })
          )
        )
        .subscribe(
          (res) => {
            if (res?.customers?.length > 0) {
              this.searchApproversList = res?.customers;
              this.searchApproversList.map(
                (item) => (item.nameEmail = `${item.name} (${item.email})`)
              );
            } else {
              this.searchApproversList = [];
            }
            this.cdr.detectChanges();
          },
          (error) => {
            this.searchApproversList = [];
          }
        );
    }
  }

  allowOnlyNumber(itemControl, controlName) {
    let val = itemControl.get(controlName).value;
    val = val.replace(/\D/g, '');
    (<FormGroup>itemControl)?.controls[controlName].setValue(
      val !== '' ? `$${val}` : ''
    );
  }
  addUpdateApprovers() {
    this.submitted = true;
    this.errorMsg = '';
    let node = {
      selectedNodeId: this.parentNode,
      contacts: this.approverForm.value.items,
    };
    this.serviceSub = this.serviceClass.addUpdateApprovers(node).subscribe(
      (res) => {
        if (res.status === 'Error') {
          this.errorMsg = res.errors[0];
          this.submitted = true;
          this.cdr.detectChanges();
        } else {
          this.modalService.dismissAll('success');
        }
      },
      (error) => {}
    );
  }
}
